<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="普通任务" name="first">
        <div class="feishu-bc">
          <img :src="imgS" alt="" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="项目任务" name="second">
        <div id="creatTask">
          <div v-show="tableShow">
            <div class="search-list">
              <el-form :inline="true" :model="formInline">
                <el-form-item label="任务标题">
                  <el-input v-model="formInline.user" placeholder="标题" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="开始日期">
                  <el-input v-model="formInline.user" placeholder="开始日期" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-input v-model="formInline.user" placeholder="结束日期" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="任务难度">
                  <el-select v-model="formInline.region" placeholder="请选择任务难度" size="mini">
                    <el-option label="困难" value="shanghai"></el-option>
                    <el-option label="普通" value="beijing"></el-option>
                    <el-option label="简单" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="任务状态">
                  <el-select v-model="formInline.region" placeholder="任务状态" size="mini">
                    <el-option label="未启动" value="shanghai"></el-option>
                    <el-option label="进行中" value="beijing"></el-option>
                    <el-option label="已完成" value="beijing"></el-option>
                    <el-option label="已停止" value="beijing"></el-option>
                    <el-option label="已暂停" value="beijing"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
                  <el-button type="info" @click="onSubmit" size="mini">重置</el-button>
                  <!-- <el-button type="warning" @click="onSubmit" size="mini">发布</el-button> -->
                </el-form-item>
              </el-form>
            </div>
            <div class="btns-wrap">
              <!-- <el-dropdown
                split-button
                type="primary"
                @click="handleClickTask"
                size="mini"
                class="edit-drop"
              >
                发布
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>指派</el-dropdown-item>
                  <el-dropdown-item>悬赏</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
            <div class="table-wrap">
              <el-table
                :data="proTaskLists"
                style="width: 100%"
              >
                <el-table-column
                  prop="name"
                  label="标题"
                  width="180"
                  align="center"
                >
                  <template v-slot="slotProp">
                    <a href="javascript:;">{{ slotProp.row.name }}</a>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  width="180"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="count"
                  label="积分"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="edit"
                  label="操作"
                  align="center"
                >
                  <el-button size="mini" type="primary">编辑</el-button>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="create-wrap" v-show="forShow">
            <h6>编辑</h6>
            <el-form :model="formInline">
              <el-form-item label="标题" class="demo-form-inline">
                <el-input
                  v-model="formInline.user"
                  placeholder="请设置任务标题"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-form-item label="开始日期">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="mini"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <div>备注</div>
                <el-input
                  v-model="formInline.user"
                  placeholder="备注"
                  type="textarea"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-form-item label="任务难度">
                <el-select
                  v-model="formInline.region"
                  placeholder="请选择任务难度"
                  size="mini"
                >
                  <el-option label="困难" value="shanghai"></el-option>
                  <el-option label="普通" value="beijing"></el-option>
                  <el-option label="简单" value="beijing"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任务状态">
                <el-select
                  v-model="formInline.region"
                  placeholder="任务状态"
                  size="mini"
                >
                  <el-option label="一般" value="shanghai"></el-option>
                  <el-option label="急" value="beijing"></el-option>
                  <el-option label="紧急" value="beijing"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="积分奖励">
                <el-input-number
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  :max="10"
                  label="积分"
                  size="mini"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="指派人员" class="el-item-flex">
                <div class="lists-yg">
                  <span class="yg-tx">李</span>
                </div>
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  size="mini"
                  class="add-yg-btn"
                ></el-button>
              </el-form-item>
              <el-form-item>
                <el-button @click="onSubmit" type="success" size="mini">完成并创建下一个</el-button>
                <el-button type="primary" @click="onSubmit" size="mini">完成</el-button>
                <el-button type="primary" @click="closeForm" size="mini">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from '@vue/composition-api'
import imgS from '@/assets/1661243792302.jpg'
export default {
  name: 'CreatTask',
  props: [

  ],
  setup () {
    let formInline = reactive({})
    let tableShow = ref(true)
    let forShow = ref(false)
    let handleClickTask = function () {
      tableShow.value = false
      forShow.value = true
    }
    let closeForm = function () {
      forShow.value = false
      tableShow.value = true
    }
    let num = ref(0)
    let value1 = ref(0)

    let activeName = ref('first')
    let handleClick = function () {}
    let onSubmit = function () {}
    let handleChange = function () {}

    // 项目列表数据
    let proTaskLists = reactive([
      {
        name: 'BSC项目',
        count: 1000,
        status: '进行中'
      },
      {
        name: '数据看板项目',
        count: 4000,
        status: '进行中'
      },
      {
        name: '自动化后台管理项目',
        count: 10200,
        status: '进行中'
      },
      {
        name: '数字可视化管理',
        count: 3000,
        status: '进行中'
      }
    ])
    return {
      proTaskLists,
      formInline,
      tableShow,
      forShow,
      handleClickTask,
      closeForm,
      num,
      handleClick,
      activeName,
      onSubmit,
      handleChange,
      value1,
      imgS
    }
  },

  components: {

  }
}
</script>

<style scoped lang="stylus">
.el-item-flex
  display: flex
  >>> .el-form-item__content
        display flex
        align-items center
.lists-yg
  display flex
  align-items: center
.add-yg-btn
  margin-left: 20px
.yg-tx
  display: inline-block
  width 20px
  height 20px
  border-radius: 50%
  background-color: #409EFF
  color: #fff
  text-align center
  line-height: 20px

.table-wrap
  .item-col
    margin-bottom 15px
    border: 1px soild #ccc
    border-radius: 10px
    border 1px solid #ccc
    padding: 10px
    .top
      display: flex
      align-items: center
      .count
        font-size: 10px
        color: red
        margin-right: 20px
      .status
        margin: 0 30px 0 20px
        width 60px
      .tags
        margin-right 15px
    .bot
      display flex
      align-items: center
      .z-user
        font-size: 14px
        width 140px
      >>> .el-progress-bar__innerText
            display inline
            vertical-align: top
      .pro-bar
        flex 1 1
        display flex
        font-size: 16px
        margin: 0 20px
        align-items center
        .sta-txt
          font-size: 16px
          &.error
            color #f56c6c
          &.warning
            color #e6a23c
          &.error
            color #f56c6c
        >>> .el-progress
              height 14px
              overflow hidden
              flex 1 1
              margin: 0 25px
              .el-progress-bar
                vertical-align: super
    .edit-drop
      margin-left: auto
    .title
      flex 1 1
      white-space nowrap
      overflow: hidden
      text-overflow: ellipsis
.flex-align-center
  display: flex
  align-items: center

.divider-line
  margin: 8px 0

.btns-wrap
  margin-bottom 15px

h6
  margin-bottom 10px

.demo-form-inline
  display flex

.tag-xs
  color #ff40f0
  border-color #f6a7ff
  background-color: #faeaff

.progress-status
  width 100px

a
  text-decoration none
</style>
